import Vue from 'vue'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

@Module({
  namespaced: true
})
export default class DashboardStore extends VuexModule {
  widgetsLoaded = false
  widgets: KwixeoDashboard.AvailableWidgets = []
  dashboardsLoaded = false
  dashboards: KwixeoDashboard.Dashboards = []

  // CLEAR STORE STATE
  @Action
  clearStore (): void {
    const elements = ['Widgets', 'Dashboards']
    elements.forEach(key => {
      this.context.commit('set' + key, [])
      this.context.commit('set' + key + 'Loaded', false)
    })
  }

  // Change the loaded state
  @Mutation
  setWidgetsLoaded (state = true): void {
    this.widgetsLoaded = state
  }

  // Set the widgets
  @Mutation
  setWidgets (widgets: KwixeoDashboard.AvailableWidgets): void {
    this.widgets = widgets
  }

  // Load the widgets for server
  @Action
  async loadWidgets (force = false): Promise<void> {
    if (!this.widgetsLoaded || force) {
      const response = await Vue.prototype.$kwDashboard.axios.get('/dashboard/widget')
      await this.context.commit('setWidgets', response.data)
      this.context.commit('setWidgetsLoaded')
    }
  }


  // Change the loaded state
  @Mutation
  setDashboardsLoaded (state = true): void {
    this.dashboardsLoaded = state
  }

  // Set the dashboards
  @Mutation
  setDashboards (dashboards: KwixeoDashboard.Dashboards): void {
    this.dashboards = dashboards
  }

  // Add or update a dashboard
  @Mutation
  updateDashboard (dashboard: KwixeoDashboard.Dashboard): void {
    if (!this.dashboardsLoaded) {
      return
    }
    const index = this.dashboards.findIndex(value => value.id === dashboard.id)
    if (index >= 0) {
      Vue.set(this.dashboards, index, dashboard)
    } else {
      this.dashboards.push(dashboard)
    }
  }

  // Remove a dashboard
  @Mutation
  removeDashboard (dashboard: KwixeoDashboard.Dashboard): void {
    if (!this.dashboardsLoaded) {
      return
    }
    const index = this.dashboards.findIndex(value => value.id === dashboard.id)
    if (index >= 0) {
      Vue.delete(this.dashboards, index)
    }
  }

  // Load the dashboards for server
  @Action
  async loadDashboards (force = false): Promise<void> {
    if (!this.dashboardsLoaded || force) {
      const response = await Vue.prototype.$kwDashboard.axios.get('/dashboard?per_page=500&sort=order&include=widgets')
      await this.context.commit('setDashboards', response.data.data)
      this.context.commit('setDashboardsLoaded')
    }
  }

  // Add or update a dashboard
  @Action
  setDashboard (dashboard: KwixeoDashboard.Dashboard): void {
    this.context.commit('updateDashboard', dashboard)
  }

  // Delete a dashboard
  @Action
  deleteDashboard (dashboard: KwixeoDashboard.Dashboard): void {
    this.context.commit('removeDashboard', dashboard)
  }
}
